"use client";
import { useGetCartQuery } from "@/api/AppApi/services/cart";
import { useEffect, useState } from "react";

interface Props {
  disabled: boolean;
  isLoading: boolean;
}

const SvgBarShoppingCart: React.FC<Props> = ({ disabled, isLoading }) => {
  const getCart = useGetCartQuery();
  const [changed, setChanged] = useState(false);
  const items = getCart.data?.result?.items;
  const itemCount = items?.length ?? 0;


  useEffect(() => {
    setChanged(true);
    animateCart();
    setTimeout(() => setChanged(false));
  }, [itemCount]);

  const animateCart = () => {
    const svgElement = document.getElementById("shopping-cart-svg");
    svgElement?.classList.add("animate-cart");

    setTimeout(() => {
      svgElement?.classList.remove("animate-cart");
    }, 1800);
  };

  return (
    <div style={{ marginTop: 5, width: 93, height: 93 }} id="shopping-cart-svg">
      <svg
        viewBox="0 0 93 92"
        width="93"
        height="92"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_7783_4722)">
          <circle
            cx="46.5"
            cy="42"
            r="30"
            className={`${disabled ? "fill-gray2" : "fill-secondary"}`} //"#EDB614"
          />
          <g clipPath="url(#clip0_7783_4722)">
            <path
              d="M30.8331 30.0001C30.7006 29.9982 30.569 30.0227 30.446 30.0721C30.3231 30.1215 30.2112 30.1949 30.1168 30.2879C30.0224 30.381 29.9475 30.4919 29.8963 30.6141C29.8452 30.7364 29.8188 30.8676 29.8188 31.0001C29.8188 31.1326 29.8452 31.2638 29.8963 31.3861C29.9475 31.5083 30.0224 31.6192 30.1168 31.7123C30.2112 31.8053 30.3231 31.8787 30.446 31.9281C30.569 31.9775 30.7006 32.002 30.8331 32.0001H32.6703C33.1556 32.0001 33.5601 32.3354 33.6521 32.8126L33.8513 33.8543L36.0011 45.1446C36.3898 47.1816 38.1845 48.6668 40.2589 48.6668H52.7406C54.815 48.6668 56.6105 47.1822 56.9985 45.1446L59.1482 33.8543C59.1758 33.7097 59.1711 33.5608 59.1345 33.4183C59.098 33.2758 59.0304 33.143 58.9366 33.0296C58.8428 32.9162 58.7252 32.8249 58.592 32.7621C58.4589 32.6994 58.3136 32.6669 58.1664 32.6668H35.6599L35.6169 32.4389C35.3482 31.0305 34.1044 30.0001 32.6703 30.0001H30.8331ZM36.0414 34.6668H56.9581L55.0336 44.7709C54.8229 45.8773 53.8676 46.6668 52.7406 46.6668H40.2589C39.1323 46.6668 38.1776 45.8773 37.9659 44.7709V44.7696L36.0414 34.6668ZM41.8331 50.0001C41.3027 50.0001 40.794 50.2108 40.4189 50.5859C40.0438 50.961 39.8331 51.4697 39.8331 52.0001C39.8331 52.5305 40.0438 53.0392 40.4189 53.4143C40.794 53.7894 41.3027 54.0001 41.8331 54.0001C42.3635 54.0001 42.8722 53.7894 43.2473 53.4143C43.6224 53.0392 43.8331 52.5305 43.8331 52.0001C43.8331 51.4697 43.6224 50.961 43.2473 50.5859C42.8722 50.2108 42.3635 50.0001 41.8331 50.0001ZM51.1664 50.0001C50.636 50.0001 50.1273 50.2108 49.7522 50.5859C49.3771 50.961 49.1664 51.4697 49.1664 52.0001C49.1664 52.5305 49.3771 53.0392 49.7522 53.4143C50.1273 53.7894 50.636 54.0001 51.1664 54.0001C51.6969 54.0001 52.2056 53.7894 52.5806 53.4143C52.9557 53.0392 53.1664 52.5305 53.1664 52.0001C53.1664 51.4697 52.9557 50.961 52.5806 50.5859C52.2056 50.2108 51.6969 50.0001 51.1664 50.0001Z"
              fill={"white"}
              className={disabled ? undefined : "dark-fill-secondary-inner"}
            />
          </g>
          {!disabled && !changed && itemCount > 0 && (
            <>
              <circle
                cx="58"
                cy="31"
                r="8"
                fill={isLoading ? "white" : "red"}
              />
              <text
                fill={"white"}
                fontSize={10}
                x="58"
                y="32"
                textAnchor="middle"
                alignmentBaseline="middle"
              >
                {itemCount}
              </text>
            </>
          )}
        </g>
        <defs>
          <filter
            id="filter0_d_7783_4722"
            x="0.5"
            y="0"
            width="92"
            height="92"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="8" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_7783_4722"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_7783_4722"
              result="shape"
            />
          </filter>
          <clipPath id="clip0_7783_4722">
            <rect
              width="32"
              height="32"
              fill="white"
              transform="translate(28.5 26)"
            />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export default SvgBarShoppingCart;
